export const environment = {
  production: true,
  apiUrl: 'https://proc-api.ospedalgrando.it/api-ogp/',
  lang: 'it',
  showHttpLogs: false,
  openTelemetryApiUrl: "https://monitoring.kedos-srl.it/collector",
  openTelemetryServiceName: "OGP-prod-fe",
  openTelemetryAttributes: "service.name=OGP-test-fe,env=prod",
};
